<template>
  <div>
    <!--{{this.$store.state.theme}}-->
    <!-- <vs-button class="mr-6" @click="submitData()">Salvar</vs-button>-->
    <div class="vx-row">
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <router-link to="/produtos">
          <statistics-card-line
            hideChart
            icon="ArchiveIcon"
            :statistic="totalProducts"
            statisticTitle="Produtos"
            color="success"
            type="area"
          ></statistics-card-line>
        </router-link>
      </div>
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <router-link to="/clientes">
          <statistics-card-line
            hideChart
            icon="UsersIcon"
            :statistic="totalCustomers"
            statisticTitle="Clientes"
            type="area"
          ></statistics-card-line>
        </router-link>
      </div>

      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <router-link to="/equipamentos">
          <statistics-card-line
            hideChart
            icon="PrinterIcon"
            :statistic="totalEquipmentOrders"
            statisticTitle="Pedidos Equipamentos"
            color="success"
            type="area"
          ></statistics-card-line>
        </router-link>
      </div>
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <router-link to="/suprimentos">
          <statistics-card-line
            hideChart
            icon="RefreshCcwIcon"
            :statistic="totalSuppliesOrders"
            statisticTitle="Pedidos Suprimentos"
            color="primary"
            type="area"
          ></statistics-card-line>
        </router-link>
      </div>
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <router-link to="/pecas">
          <statistics-card-line
            hideChart
            icon="SettingsIcon"
            :statistic="totalPartsOrders"
            statisticTitle="Pedidos Peças"
            color="danger"
            type="area"
          ></statistics-card-line>
        </router-link>
      </div>
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <router-link to="/suprimentos-locacao">
          <statistics-card-line
            hideChart
            icon="TruckIcon"
            :statistic="totalLeaseSuppliesOrders"
            statisticTitle="Suprimentos Locação"
            color="dark"
            type="area"
          ></statistics-card-line>
        </router-link>
      </div>
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <router-link to="/mao-de-obra">
          <statistics-card-line
            hideChart
            icon="CheckSquareIcon"
            :statistic="totalLaborOrders"
            statisticTitle="Mão de Obra"
            color="warning"
            type="area"
          ></statistics-card-line>
        </router-link>
      </div>
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <router-link to="/locacao">
          <statistics-card-line
            hideChart
            icon="EditIcon"
            :statistic="`${totalLeaseOrders} / ${totalGoldOrders}`"
            statisticTitle="Locação / Ouro"
            color="lease"
            type="area"
          ></statistics-card-line>
        </router-link>
      </div>
    </div>

    <!--<input
              type="file" 
              ref="uploadPDF"
              @change="updateCurrImg"
               accept="application/pdf"
              name="updateCurrImg"
            />
  <vs-button @click="upload">Upload Foto</vs-button>
<vs-button @click="download()">Download</vs-button>-->
    <!--{{this.$store.state.user}}-->
  </div>
</template>


<script>
import { baseApiUrl, userKey, avatarPhoto } from "@/global";
import axios from "axios";
import Page2 from "./Page2";
import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";
export default {
  components: { Page2, StatisticsCardLine },
  data() {
    return {
      backgroundLoading: "primary",
      colorLoading: "#fff",
      file: "",
      fileName: "",
    };
  },
  computed: {
    totalCustomers() {
      return this.$store.state.customers.totalItems;
    },
    totalProducts() {
      return this.$store.state.totalProducts;
    },
    totalEquipmentOrders() {
      return this.$store.state.equipments.totalEquipmentOrders;
    },
    totalSuppliesOrders() {
      return this.$store.state.supplies.totalSuppliesOrders;
    },
    totalPartsOrders() {
      return this.$store.state.parts.totalPartsOrders;
    },
    totalLaborOrders() {
      return this.$store.state.labor.totalLaborOrders;
    },
    totalLeaseOrders() {
      return this.$store.state.lease.totalLeaseOrders;
    },
    totalGoldOrders() {
      return this.$store.state.gold.totalGoldOrders;
    },
    totalLeaseSuppliesOrders() {
      return this.$store.state.leaseSupplies.totalLeaseSuppliesOrders;
    },
  },
  methods: {
    async getUserInfo() {
      let res = await axios.get(`${baseApiUrl}/userInfo`);
    },

    async submitData() {
      let res = await axios.get(`${baseApiUrl}/equipmentOrder/report`, {
        responseType: "blob",
      });

      let blob = new Blob([res.data], { type: "application/pdf" }),
        url = window.URL.createObjectURL(blob);
      window.open(url);
    },
    /*
   
    async upload(){
   
        let dados = {
          fileName : this.fileName,
          file : this.file
        }
       let res = await axios.post(`${baseApiUrl}/product/teste`, dados)
       console.log(res)
      console.log(this.file)
      console.log(this.fileName)
    },
    updateCurrImg(input) {

      if (input.target.files && input.target.files[0]) {
        var reader = new FileReader();
        reader.onload = (e) => {
      
          this.file = e.target.result
          this.fileName = input.target.files[0].name
        };
    
        reader.readAsDataURL(input.target.files[0]);
      }
    },
    
    async getBlob() {
      //Abre uma Janela nova com o PDF
      let res = await axios.get(`${baseApiUrl}/product/downteste`, {
        responseType: "blob"
      });
      // responseType: 'blob', // important
      let blob = new Blob([res.data], { type: 'application/pdf' }),
      //let blob = new Blob([res.data], { type: "image/jpg" }),
      url = window.URL.createObjectURL(blob);
      this.imgBlob = url;
      window.open(url)
    },
    async download() {
       //Download Simples
      let res = await axios.get(`${baseApiUrl}/product/downteste`, {
        responseType: "arraybuffer"
      });

      // responseType: 'blob', // important
      //let blob = new Blob([res.data], { type: 'application/pdf' }),
      //let blob = new Blob([res.data], { type: 'image/jpg' }),
      //url = window.URL.createObjectURL(blob)
      //window.open(url)
  
      this.forceFileDownload(res);
    },
    forceFileDownload(response) {
      console.log(response)
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "file.pdf"); //or any other extension
      document.body.appendChild(link);
      link.click();
    },   */
  },
  created() {
    let payload = { 
      loading: this.$vs.loading,
      type: "all",
      userGroup: this.$store.state.user.userGroup,
    };
    this.$store.dispatch("equipments/fetchTotalEquipmentOrder", payload);
    this.$store.dispatch("supplies/fetchTotalSuppliesOrder", payload);
    this.$store.dispatch("parts/fetchTotalPartsOrder", payload);
    this.$store.dispatch("labor/fetchTotalLaborOrder", payload);
    this.$store.dispatch("lease/fetchTotalLeaseOrder", payload);
    this.$store.dispatch("leaseSupplies/fetchTotalLeaseSuppliesOrder", payload);
    this.$store.dispatch("gold/fetchTotalGoldOrder", payload);
    this.$store.dispatch("fetchProductsItems", payload);
    this.$store.dispatch("customers/fetchCustomersItems", payload);
    this.$store.dispatch("fetchTotalProducts", payload);

    this.getUserInfo();
  },
};
</script>
 
<style lang="scss">
/*! rtl:begin:ignore */
#dashboard-analytics {
  .greet-user {
    position: relative;

    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }
    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media (max-width: 576px) {
    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
}
/*! rtl:end:ignore */
</style>